var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconCanoeRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A202C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 13.562c0-1.699.62-3.85 1.177-4.73l.42-.657.202.755c.263.973 1.599 1.703 3.443 2.186 1.658.433 3.703.65 5.758.65 2.054 0 4.1-.216 5.759-.65 1.843-.48 3.18-1.213 3.442-2.186l.202-.755.42.658c.558.883 1.177 3.001 1.177 4.695 0 .517-.056 1.002-.194 1.41-.145.446-.382.802-.734 1.019a1.536 1.536 0 0 1-.825.225H3.688a1.44 1.44 0 0 1-.786-.216c-.344-.212-.575-.565-.718-1.007-.128-.403-.184-.883-.184-1.397z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.577 7.36 3.3-3.261a.349.349 0 0 1 .487 0c.039.038.064.08.081.126l2.531 5.566a.342.342 0 0 1-.076.386l-.18.178-.086-.085.086.085a.345.345 0 0 1-.408.056L4.678 7.91l.142-.31-.142.31c-.172-.076-.248-.277-.172-.45a.283.283 0 0 1 .077-.106l-.006.005zM23.627 19.634l-3.3 3.26a.348.348 0 0 1-.563-.094l.314-.14-.314.14-2.532-5.565a.337.337 0 0 1 .056-.403l.18-.178a.349.349 0 0 1 .391-.076l5.634 2.501a.339.339 0 0 1 .128.56l.006-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.764 7.758a.349.349 0 0 0-.486 0 .339.339 0 0 0 0 .48l3.18 3.142h.017l.047.005h.034l.047.004h.052l.064.005h.017l.077.004h.099l.064.005h.528L8.8 7.743l-.036.015zm7.893 8.763 2.274 2.247a.349.349 0 0 0 .485 0 .339.339 0 0 0 0-.48L17.63 16.52h-.972z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCanoeRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-canoe-regular.429da215.svg";
export { ForwardRef as ReactComponent };